window.pedirTodo = function (catalogo_id) {
    cleanFeedback('pedirTodo', 'pedirTodo');
    $.confirm({
        columnClass: 'col-md-6',
        icon:        'ri-alert-fill ri-xxs',
        title:       transAccionAtencion,
        type:        'orange',
        content:     transConfirmacionCrearPedido,
        buttons:     {
            confirm: {
                text:     transAccionEnviar,
                btnClass: 'btn btn-success float-end',
                action:   function () {
                    $.ajax({
                        url:        urlPedido + '/store-by-catalogo-id/' + catalogo_id,
                        type:       'POST',
                        dataType:   'json',
                        beforeSend: function () {
                            $('#buttonActionOrderEverything' + catalogo_id).prop('disabled', true);
                            $('#buttonActionOrderEverything' + catalogo_id).html(`<i class="ri-loader-4-line spinner"></i>${transAccionProcesando}`);
                        },
                    })
                     .done(function (response) {
                         $('#pedirTodo' + catalogo_id + 'Exito')
                             .show()
                             .find('span')
                             .text(response);
                     })
                     .fail(function (jqXHR, status, error) {
                         showInvalidFeedback(jqXHR, 'pedirTodo' + catalogo_id, 'pedirTodo');
                     })
                     .always(function () {
                         $('#buttonActionOrderEverything' + catalogo_id).prop('disabled', false);
                         $('#buttonActionOrderEverything' + catalogo_id).html(`<i class="ri-shopping-cart-line"></i>${transCatalogoInfoComprarLote}`);
                     });
                }
            },
            cancel:  {
                text:     transAccionCancelar,
                btnClass: 'btn btn-light float-start',
            },
        },
    });
}
